import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { trackPageview, trackWebVitals } from '@/lib/analytics';
import { removeLegacyAdTracking } from '@/lib/legacy-ad-cleanup';
import { SITE_LOCALE } from '@/lib/site-config';

/**
 * Sends one pageview per route. Lives inside <BrowserRouter> so it sees SPA
 * navigations, which a plain script tag in index.html would miss.
 *
 * Renders nothing.
 */
export function RumTracker() {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    trackWebVitals();
    removeLegacyAdTracking();
  }, []);

  useEffect(() => {
    // React 18 mounts effects twice in dev, and a replaced search string is not
    // a new page: only a changed path counts.
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    trackPageview(location.pathname, SITE_LOCALE);
  }, [location.pathname]);

  return null;
}
